<template>
    <div class="comments" v-if="loadComments">
        <div class="sub_line">
            <span v-if="type === 'recommend'">Hot comments</span>
            <span v-else>Latest comments</span>
        </div>
        <ul id="comment_list">
            <li v-for="com in comments">
                <img class="avatar" alt="avatar" :src="getImgSrc(com.user.avatar)"
                     onerror="javascript:this.src='https://img1.dongqiudi.com/fastdfs1/M00/3B/EF/o4YBAFjM9lqAel9GAAAQrsgeQ3A103.jpg'">
                <div class="user_info">
                    <p class="name">
                        <span>{{com.user.username}}</span>
                        <span v-show="(com.user.medal_id!=0)" class="icon_v"></span>
                        <span v-if="com.user.team_icon" class="icon_team"
                              :style="{backgroundImage:'url('+ getImgSrc(com.user.team_icon) +')'}"></span>
                        <span v-show="com.user.is_root" class="icon_author">author</span>
                    </p>
                    <p class="commend">
                        {{com.up}}
                        <span v-bind:class="{ hot: type === 'recommend' }"></span>
                    </p>
                    <div style="clear:both;"></div>
                </div>
                <div class="date">{{formatDate(com.created_at)}}</div>
                <div v-if="com.quote" class="quote">
                    <div class="quote_author">
                        <span>{{com.quote.user.username}}</span>
                        <span v-show="(com.quote.user.medal_id!=0)" class="icon_v"></span>
                        <span v-if="com.quote.user.team_icon" class="icon_team"
                              :style="{backgroundImage:'url('+ getImgSrc(com.quote.user.team_icon) +')'}"></span>
                        <span v-show="com.quote.user.is_root" class="icon_author">author</span>
                    </div>
                    <p v-html="com.quote.content" class="quote_con"></p>
                </div>
                <div class="detail">
                    <p class="text_con" v-html="com.content"></p>
                    <div v-if="(imgMode = 'on')" class="pic_con">
                        <div class="img_con" v-bind:class="(com.attachments_total>1)? 'multiple':'single'"
                             v-for="pic in com.attachments">
                            <img :src="getImgSrc(pic.thumb)">
                            <template v-if="pic.mime === 'image/gif'">
                                <div class="media-holder"></div>
                                <div class="media-label"></div>
                            </template>
                        </div>
                    </div>
                    <div v-else>
                        [images]
                    </div>
                </div>
            </li>
        </ul>

        <div class="more_comment" v-if="isInApp">
            <a v-if="comments.length > 0" :href="'allfootball:///comment/' + article_id">
                <img class="message-icon" src="../assets/icon_message.jpg" alt="">{{ $t('readMore') }} >
            </a>
            <a class="no_comment" v-else :href="'allfootball:///post_comments/' + article_id">
                {{ $t('noCommented') }}
            </a>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    import axios from 'axios';

    export default {
        name: 'comments',
        props: ['articleId', 'time'],
        data () {
            return {
                isInApp: process.env.VUE_ENV === 'server' ? !this.$ssrContext || this.$ssrContext.inApp : _IS_IN_ALL_FOOTBALL,
                componentsShow: false,
                comments: [],
                type: 'normal',
                article_id: this.articleId,
                loadComments: false,
                isExternalAccess: null
            };
        },
        methods: {
            init: function () {
                let that = this;
                axios.get('/m/archives/recommend_comments/' + this.article_id + '?plat=m').then((response) => {
                    that.type = response.data.type;
                    if (response.data.comments && response.data.comments.length > 0) {
                        that.loadComments = true;
                    } else {
                        return;
                    }
                    for (let i = 0; i < response.data.comments.length; i++) {
                        Vue.set(that.comments, i, response.data.comments[i]);
                    }
                }, (error) => {
                });
            },
            formatDate: function (gmtDate) {
                // todo
                // 抽象
                Date.prototype.Format = function (fmt) {
                    var o = {
                        'M+': this.getMonth() + 1, //月份
                        'd+': this.getDate(), //日
                        'h+': this.getHours(), //小时
                        'm+': this.getMinutes(), //分
                        's+': this.getSeconds(), //秒
                        'q+': Math.floor((this.getMonth() + 3) / 3), //季度
                        'S': this.getMilliseconds() //毫秒
                    };
                    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
                    for (var k in o)
                        if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)));
                    return fmt;
                };
                let date = new Date(gmtDate.replace(/-/g, '/')).getTime();
                let diff_min = new Date().getTimezoneOffset();
                let local_date = new Date(date - diff_min * 60 * 1000);
                let same_year = local_date.getFullYear() === (new Date().getFullYear());
                return (local_date).Format(same_year ? 'MM-dd hh:mm' : 'yyyy-MM-dd hh:mm');

            }
        },
        mounted () {
            this.isExternalAccess = window.location.hostname.indexOf('quanshizuqiu') > -1;
            if (this.isExternalAccess) {
                import('@/util/sys-color-qszq.css').then(module => {
                    console.log('module',module)
                // CSS 已加载
                // 如果使用 CSS Modules，可以通过 module.default 访问
                });
            } else {
                import('@/util/sys-color.css').then(module => {
                // CSS 已加载
                });
            }
            // setTimeout(() => {
            //     this.componentsShow = true;
            // }, this.time);
            this.init();
        }
    };
</script>
<style lang="less">
    .comments {
        margin: 0;
        padding: 0;
        width: 100%;
    }

    .comments .sub_line span {
        display: inline-block;
        height: 20px;
        font-size: 15px;
        font-weight: 600;
        color: #2d2f32;
        line-height: 20px;
    }

    .comments .sub_line span:before {
        display: inline-block;
        height: 24px;
        width: 3px;
        margin-right: 12px;
        vertical-align: middle;
        content: "";
        background-color: var(--mainColor);
    }

    #comment_list {
        margin: 18px 0 18px;
        padding: 0;
    }

    #comment_list li {
        list-style: none;
        position: relative;
        padding: 0 15px 0 15px;
        margin-bottom: 12px;
        overflow: hidden;
        border-bottom: solid #eff1f4 1px;
    }

    #comment_list .quote {
        margin: 14px 0 6px;
        padding: 10px 12px 8px;
        background: #eff1f4;
        color: #999;
        border-radius: 3px;
    }

    #comment_list .quote .icon_author {
        position: relative;
        bottom: 1px;
    }

    #comment_list .quote p {
        margin: 0;
        font-size: 14px;
        word-break: break-word;
    }

    #comment_list .quote_author {
        color: #2d2f32;
        font-size: 14px;
        height: 16px;
        line-height: 16px;
        margin-bottom: 4px;
    }

    #comment_list .quote_author span {
        display: inline-block;
        vertical-align: middle;
    }

    #comment_list .avatar {
        position: absolute;
        top: 4px;
        left: 15px;
        height: 30px;
        width: 30px;
        border-radius: 50%;
    }

    #comment_list .user_info {
        margin-bottom: 0;
        font-size: 14px;
        width: 100%;
        padding: 0;
    }

    #comment_list .user_info .name {
        margin: 0 0 0 38px;
        color: var(--mainColor);
        float: left;
    }

    #comment_list .user_info p span {
        height: 20px;
        line-height: 20px;
        font-size: 12px;
        display: inline-block;
        vertical-align: middle;
    }

    #comment_list .icon_v {
        background-image: url(https://static1.dongqiudi.com/web-new/static/img/V_con_v2.png);
        background-position: center center;
        background-size: 100% auto;
        background-repeat: no-repeat;
        display: inline-block;
        height: 13px;
        width: 13px;
    }

    #comment_list .icon_author {
        height: 16px;
        line-height: 16px;
        margin-left: 4px;
        font-size: 12px;
        padding: 0 4px;
        background: #16ac3a;
        color: #ffffff;
        border-radius: 4px;
    }

    #comment_list .icon_team {
        position: relative;
        bottom: 1px;
        background-position: center center;
        background-size: 100% auto;
        background-repeat: no-repeat;
        display: inline-block;
        height: 16px;
        width: 16px;
    }

    #comment_list .user_info .commend {
        position: relative;
        top: 1px;
        margin: 0;
        height: 20px;
        line-height: 20px;
        vertical-align: middle;
        font-size: 12px;
        color: #8c9399;
        float: right;
    }

    #comment_list .user_info .commend span {
        position: relative;
        bottom: 3px;
        background-image: url(../assets/icon_agree_def.png);
        background-position: center center;
        background-size: 100% auto;
        background-repeat: no-repeat;
        display: inline-block;
        height: 24px;
        width: 24px;
    }

    #comment_list .user_info .commend .hot {
        background-image: url(../assets/icon_agree_hot.png);
        background-position: center center;
        background-size: 100% auto;
        background-repeat: no-repeat;
    }

    #comment_list .detail {
        margin: 8px 0 12px;
        font-size: 16px;
        color: #333;
    }

    #comment_list .detail .text_con {
        line-height: 24px;
        margin: 0;
        word-break: break-word;
    }

    #comment_list .detail .pic_con {
        margin-top: 4px;
    }

    #comment_list .detail .pic_con .img_con {
        display: inline-block;
        position: relative;
        overflow: hidden;
    }

    #comment_list .pic_con img {
        width: 100%;
        border-radius: 2px;
    }

    #comment_list .pic_con .single {
        max-height: 336px;
        width: 73%;
    }

    #comment_list .pic_con .multiple {
        width: 32%;
    }

    #comment_list .pic_con .multiple:not(:last-child) {
        margin-right: 2%;
    }

    #comment_list img.face {
        position: relative;
        top: -1px;
        height: 24px;
        width: auto;
        vertical-align: top;
    }

    #comment_list .pic_con .media-holder {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 999;
        width: 100%;
        height: 100%;
        background: url(../assets/play@80x80.png) no-repeat center center;
        background-size: 40px 40px;
    }

    #comment_list .pic_con .media-label {
        position: absolute;
        top: 0;
        left: 0;
        background: url(../assets/gif_comments.png) 0 0 no-repeat;
        width: 20px;
        height: 20px;
        background-size: 100% 100%;
        text-indent: 1000px;
    }

    #comment_list .date {
        font-size: 10px;
        color: #999999;
        margin: 0 0 0 38px;
    }

    .more_comment {
        font-size: 16px;
        text-align: center;
        margin: 36px 0;
        > a {
            color: var(--mainColor);
        }
        .no_comment {
            color: #b5bcc4;
            font-weight: 400;
        }
        .message-icon {
            width: 17px;
            vertical-align: middle;
            margin-right: 9px;
        }
    }
</style>



// WEBPACK FOOTER //
// comments.vue?4f2a3650